/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { USER_REDUCER_KEY, userReducer } from './+state/user.reducer';
import { EffectsModule } from '@ngrx/effects';
import { UserEffects } from './+state/user.effects';
import { PasswordRecoverySuccessPageComponent } from '@nai-libs/standalone/password-recovery-success-page';
import { PasswordResetSuccessPageComponent } from '@nai-libs/standalone/password-reset-success-page';
import { PasswordChangeSuccessPageModule } from '@nai-libs/user/features/change-password-feature/src/lib/standalone/password-change-success-page/password-change-success-page.module';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(USER_REDUCER_KEY, userReducer),
    EffectsModule.forFeature([UserEffects]),
    PasswordRecoverySuccessPageComponent,
    PasswordResetSuccessPageComponent,
    PasswordChangeSuccessPageModule,
    HttpClientModule,
  ],
})
export class UserDataAccessModule {}
